module.exports = __webpack_public_path__ + "static/img/ex_logo_19.048e363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_ex/ex_logo_19.jpg
// module id = QNVj
// module chunks = 0